module.exports = __webpack_public_path__ + "img/header-img-2.51105eb0.png";